<template>
  <div>
    <p>总数量：{{ num }}</p>
    <el-table
      :data="tableData"
      border
    >
      <el-table-column
        v-for="(item, index) in tableField"
        :key="index"
        :prop="item.field"
        :label="item.label"
      />
    </el-table>
  </div>
</template>
<script>

export default {
  name: 'ProdTable',
  data() {
    return {
      num: 0,
      tableData: [],
      tableField: [],
      skinTitle: ['野兽ID', '骰子ID', '盾牌ID'],
      skinNameTitle: ['野兽', '骰子', '盾牌'],
      tableFieldArr: [
        { field: 'skin', label: '野兽ID' },
        { field: 'skinName', label: '野兽' },
        { field: 'num', label: '数量' },
        { field: 'status', label: '状态' }
      ]
    }
  },
  created() {
    this.tableField = this.tableFieldArr
  },
  methods: {
    init(data, index) {
      this.tableFieldArr[0].label = this.skinTitle[index]
      this.tableFieldArr[1].label = this.skinNameTitle[index]
      this.tableData = data
      this.num = 0
      if (this.tableData.length > 0) {
        this.tableData.forEach(item => {
          this.num += item.num
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
